import { BaseModel } from "@/models/base.model"
import { type ITenantSettings } from "@/interfaces/api/tenant-settings.interface"
import { InstructionFeedbackActivityTypeSetting } from "@/models/tenant_settings/instruction-feedback-activity-type-setting.model"
import { ModelFactory } from "@/factories/model-factory"

export class TenantSettings extends BaseModel implements ITenantSettings {
  public static className = "TenantSettings"

  public static verboseName = "tenant settings"

  apiKeyGoogleMaps: string | null

  instructionFeedbackActivityTypeSettings: InstructionFeedbackActivityTypeSetting[]

  productionStatementFooterText: string | null
  productionStatementPdfLogo: string | null
  quoteOpeningText: string | null
  quoteClosingText: string | null
  quoteConditionsReferenceText: string | null
  quoteConditionsText: string | null
  quoteDefaultSigningPlace: string | null
  quoteHeaderHeightMm: number | null
  quoteFooterHeightMm: number | null
  letterhead: string | null

  constructor(tenantSettings: ITenantSettings, managed = false) {
    super(tenantSettings)

    this.apiKeyGoogleMaps = tenantSettings.apiKeyGoogleMaps
    this.instructionFeedbackActivityTypeSettings = ModelFactory.childModels(
      InstructionFeedbackActivityTypeSetting,
      tenantSettings.instructionFeedbackActivityTypeSettings,
      managed
    )
    this.productionStatementFooterText = tenantSettings.productionStatementFooterText
    this.productionStatementPdfLogo = tenantSettings.productionStatementPdfLogo
    this.quoteOpeningText = tenantSettings.quoteOpeningText
    this.quoteClosingText = tenantSettings.quoteClosingText
    this.quoteConditionsReferenceText = tenantSettings.quoteConditionsReferenceText
    this.quoteConditionsText = tenantSettings.quoteConditionsText
    this.quoteDefaultSigningPlace = tenantSettings.quoteDefaultSigningPlace
    this.quoteHeaderHeightMm = tenantSettings.quoteHeaderHeightMm
    this.quoteFooterHeightMm = tenantSettings.quoteFooterHeightMm
    this.letterhead = tenantSettings.letterhead
  }
}
